module.exports = __webpack_public_path__ + "img/personAvator.png";